<template>
  <highcharts
    :ref="`ascBoxChart${_uid}`"
    class="highcharts"
    :options="chartOptions"
  ></highcharts>
</template>

<script>
export default {
  name: 'AscBoxChart',

  props: {
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      chartRef: null,
      chartOptions: this.options,
    }
  },

  watch: {
    options: {
      deep: true,
      handler(newObj) {
        this.chartOptions = newObj
      },
    },
  },

  mounted() {
    this.chartRef = this.$refs[`ascBoxPlotChart${this._uid}`]
  },
}
</script>

<style lang="scss" scoped>
.highcharts {
  width: 100%;
  margin: 0 auto;
}
</style>
